export default {"src":"/_next/static/image/public/images/ic_right_arrow_white.04db176db07f6eaf34ad2c3ddb717a2f.svg","height":14,"width":8};